import moment from 'moment';

const state = {
	conversationProviders: {},
	curConversation: {
		providerName: null,
		conversationId: null
	}
};

const getters = {
	state_curConversation: ({ curConversation }) => {
		return curConversation;
	},

	getAllConversationProviders: state => {
		let conversationProviders = [];

		for (let providerI in state.conversationProviders) {
			let provider = state.conversationProviders[providerI];

			conversationProviders.push(provider);
		}

		return conversationProviders;
	},
	getConversationProvider: state => providerName => {
		if (state.conversationProviders.hasOwnProperty(providerName)) {
			return state.conversationProviders[providerName];
		} else {
			console.debug('no such provider with name', providerName);
			return null;
		}
	},
	getCurConversationProvider: (state, getters) => {
		let providerName = state.curConversation.providerName;
		if (providerName) {
			return getters.getConversationProvider(providerName);
		} else {
			console.debug('no current conversation');
			return null;
		}
	},

	isAvailable: (state, getters) => providerName => {
		return getters['provider_' + providerName + '/isAvailable'];
	},
	isReady: (state, getters) => providerName => {
		return getters['provider_' + providerName + '/isReady'];
	},

	oneProviderMode: (state, getters) => {
		console.debug(
			'checking for oneProviderMode',
			getters.getAllConversationProviders.length
		);
		return getters.getAllConversationProviders.length === 1;
	},

	getAllConversations: (state, getters) => {
		let conversations = [];

		for (
			let providerI = 0;
			providerI < getters.getAllConversationProviders.length;
			providerI++
		) {
			let provider = getters.getAllConversationProviders[providerI];

			if (
				!getters.isAvailable(provider.name) ||
				!getters.isReady(provider.name)
			) {
				continue;
			}
			for (let conversationI in provider.conversations) {
				let conversation = provider.conversations[conversationI];

				conversations.push(conversation);
			}
		}

		conversations.sort((a, b) => {
			if (!a.lastMessage) {
				return 1;
			}
			if (!b.lastMessage) {
				return -1;
			}

			return moment(a.lastMessage.dateAdded, 'x').isBefore(
				moment(b.lastMessage.dateAdded, 'x')
			)
				? 1
				: -1;
		});

		return conversations;
	},
	getConversation: state => (providerName, conversationId) => {
		if (state.conversationProviders.hasOwnProperty(providerName)) {
			if (
				state.conversationProviders[
					providerName
				].conversations.hasOwnProperty(conversationId)
			) {
				return state.conversationProviders[providerName].conversations[
					conversationId
				];
			}
		}
		return null;
	},
	getCurConversation: (state, getters) => {
		let providerName = state.curConversation.providerName;
		let conversationId = state.curConversation.conversationId;
		if (providerName && conversationId) {
			return getters.getConversation(providerName, conversationId);
		} else {
			console.debug('no current conversation');
			return null;
		}
	},

	getConversationMessages: (state, getters) => (
		providerName,
		conversationId
	) => {
		let conversation = getters.getConversation(
			providerName,
			conversationId
		);

		let messages = [];

		for (let msgII = 0; msgII < conversation.messagekeys.length; msgII++) {
			let msgI = conversation.messagekeys[msgII];

			let msg = state.conversationProviders[providerName].messages[msgI];

			if (msg) {
				messages.unshift(msg);
			}
		}

		messages.sort((a, b) => {
			return moment(a.dateAdded, 'x').isBefore(moment(b.dateAdded, 'x'))
				? 1
				: -1;
		});

		return messages;
	},
	getCurConversationMessages: (state, getters) => {
		let providerName = state.curConversation.providerName;
		let conversationId = state.curConversation.conversationId;
		if (providerName && conversationId) {
			return getters.getConversationMessages(
				providerName,
				conversationId
			);
		} else {
			console.debug('no current conversation');
			return null;
		}
	},

	getConversationProviderUser: (state, getters) => providerName => {
		if (state.conversationProviders.hasOwnProperty(providerName)) {
			return getters['provider_' + providerName + '/getCurUser'];
		}
		return null;
	},
	getCurConversationUser: (state, getters) => {
		let providerName = state.curConversation.providerName;
		if (providerName) {
			return getters.getConversationProviderUser(providerName);
		} else {
			console.debug('no current conversation');
			return null;
		}
	},

	validateMessage: (state, getters) => messageBody => {
		let providerName = state.curConversation.providerName;
		let conversationId = state.curConversation.conversationId;
		if (providerName) {
			return getters['provider_' + providerName + '/validateMessage'](
				messageBody,
				conversationId
			);
		}
	}
};

const mutations = {
	registerConversationProvider(state, name) {
		state.conversationProviders[name] = state['provider_' + name];
	},

	changeConversation(state, [providerName, conversationId]) {
		state.curConversation.providerName = providerName;
		state.curConversation.conversationId = conversationId;
	}
};

const actions = {
	addConversationProvider({ commit, dispatch }, providerName) {
		commit('registerConversationProvider', providerName);
		dispatch('provider_' + providerName + '/init');
	},

	sendMessage({ dispatch }, [providerName, conversationId, messageBody]) {
		let messageData = dispatch(
			'provider_' + providerName + '/sendMessage',
			[conversationId, messageBody]
		);
		return messageData;
	},

	sendMessage2Cur({ state, dispatch }, messageBody) {
		let providerName = state.curConversation.providerName;
		let conversationId = state.curConversation.conversationId;
		messageBody = encodeURIComponent(messageBody);
		if (providerName && conversationId) {
			let messageData = dispatch('sendMessage', [
				providerName,
				conversationId,
				messageBody
			]);
			return messageData;
		} else {
			console.debug('no current conversation');
			return null;
		}
	},

	updateTyping({ state, dispatch }, to = false) {
		let providerName = state.curConversation.providerName;
		let conversationId = state.curConversation.conversationId;
		if (providerName && conversationId) {
			dispatch('provider_' + providerName + '/updateTyping', [
				conversationId,
				to
			]);
		}
	}
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
